import {
  Button,
  Chip,
  CircularProgress,
  IconButton,
  ImageListItemBar,
  Stack,
  Typography,
} from "@mui/material";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import OrderPrizeDialog from "../components/OrderPrizeDialog";
import { useDispatch, useSelector } from "react-redux";
import { setNotification } from "../redux/slices/notificationsSlice";
import { useTranslation } from "react-i18next";
import FlagCircleIcon from "@mui/icons-material/FlagCircle";
import {
  getAllClientGifts,
  getAllUserPrizeHistory,
} from "../redux/slices/giftsProductsSlice";
import { getMe } from "../redux/slices/userSlice";
import InfoIcon from "@mui/icons-material/Info";
import InstructionAlertModal from "../components/InstructionAlertModal";

const GiftPage = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedGift, setSelectedGift] = useState();
  const [showInstallInfoModal, setShowInstallInfoModal] = useState(false);

  const userTotalPoints = useSelector(
    (state) => state.user.userMe?.current_points
  );
  const allGifts = useSelector((state) => state.giftsProducts.allGifts);
  const getAllClientGiftsLoading = useSelector(
    (state) => state.giftsProducts.getAllClientGiftsLoading
  );
  const userMe = useSelector((state) => state.user.userMe);
  const allUserPrizes = useSelector(
    (state) => state.giftsProducts.allUserPrizes
  );

  useEffect(() => {
    dispatch(getMe()).then(() => {
      dispatch(getAllClientGifts());
      dispatch(getAllUserPrizeHistory());
    });
  }, [dispatch]);

  const openPrizeDialog = (gift) => {
    if (gift.stock <= 0) return;
    if (isPrizeDisabled(gift)) {
      return;
    }
    setSelectedGift(gift);
    setOpenDialog(true);
  };
  const onCloseOrderPrizeDialog = () => {
    setSelectedGift(null);
    setOpenDialog(false);
  };
  const handleOnSuccessOrderGift = () => {
    setOpenDialog(false);
    dispatch(getMe()).then(() => {
      dispatch(getAllClientGifts());
      dispatch(getAllUserPrizeHistory());
    });
    dispatch(
      setNotification({
        show: true,
        message: t("notifications.successOrderGift"),
        severity: "success",
      })
    );
  };
  const openInstallExplanationModal = () => {
    setShowInstallInfoModal(true);
  };
  const onCloseInstallExplanationModal = () => {
    localStorage.setItem("openInfoAutomatically", "false");
    setShowInstallInfoModal(false);
  };

  const isPrizeDisabled = (prize) => {
    const prizeNameLimit = prize.name === "Privezak" ? 10 : 2;
    const isDisabled =
      allUserPrizes?.filter((p) => p.prize.objectId === prize.objectId)
        .length >= prizeNameLimit;
    return isDisabled;
  };

  useEffect(() => {
    let openInfo = localStorage.getItem("openInfoAutomatically");
    openInfo =
      openInfo === null ? true : openInfo === "false" ? false : openInfo;
    setShowInstallInfoModal(openInfo);
  }, []);
  useEffect(() => {
    dispatch(getMe()).then(() => dispatch(getAllUserPrizeHistory()));
  }, [dispatch]);

  return (
    <Box>
      {getAllClientGiftsLoading === "PENDING" ? (
        <Stack
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
        >
          <CircularProgress color="error" />
        </Stack>
      ) : (
        <>
          <Stack
            display="flex"
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            padding="24px 12px 0px 12px"
          >
            <Button
              type="icon"
              size="small"
              color="error"
              onClick={openInstallExplanationModal}
            >
              <InfoIcon />
            </Button>
            <Stack
              direction="row"
              display="flex"
              alignItems="center"
              justifyContent="end"
            >
              <Typography component="div" marginRight="4px" color="error">
                {t("giftPage.youHaveTotalPoints")}
              </Typography>
              <Chip
                color="error"
                icon={<FlagCircleIcon />}
                label={userTotalPoints}
              />
            </Stack>
          </Stack>
          <Stack maxHeight="80vh">
            <ImageList variant="masonry" cols={2} gap={8}>
              {allGifts?.map((item) => (
                <ImageListItem
                  key={item.objectId}
                  onClick={() => openPrizeDialog(item)}
                  className={{
                    disabledPrize: item.stock === 0 || isPrizeDisabled(item),
                    // ||
                    // (item.name !== "Privezak" &&
                    //   userMe.prizes_purchased >= 2) ||
                    // (item.name === "Privezak" &&
                    //   userMe.prizes_purchased >= 10),
                  }}
                >
                  <img
                    src={`${item.photo?.url}?w=161&fit=crop&auto=format`}
                    srcSet={`${item.photo?.url}?w=161&fit=crop&auto=format&dpr=2 2x`}
                    alt={item.title}
                    loading="lazy"
                  />
                  <ImageListItemBar
                    title={item.name}
                    subtitle={t("giftPage.onStock", { num: item.stock })}
                    actionIcon={
                      <IconButton
                        sx={{ color: "rgba(255, 255, 255, 0.54)" }}
                        aria-label={`info about ${item.name}`}
                      >
                        <Chip label={item.points + " poena"} color="error" />
                      </IconButton>
                    }
                  />
                </ImageListItem>
              ))}
            </ImageList>
          </Stack>
        </>
      )}
      {openDialog && (
        <OrderPrizeDialog
          open={openDialog}
          onClose={onCloseOrderPrizeDialog}
          totalPoints={userTotalPoints}
          selectedGift={selectedGift}
          onSuccessOrderGift={handleOnSuccessOrderGift}
        />
      )}
      {showInstallInfoModal && (
        <InstructionAlertModal
          open={showInstallInfoModal}
          onClose={onCloseInstallExplanationModal}
          onConfirm={onCloseInstallExplanationModal}
        />
        // <AlertDialogComponent
        //   open={showInstallInfoModal}
        //   onClose={onCloseInstallExplanationModal}
        //   subtitle={t("giftPage.infoInstallModalSubTitle")}
        //   text={t("giftPage.infoInstallModalText")}
        //   text2={t("giftPage.infoInstallModalText2")}
        //   onConfirm={onCloseInstallExplanationModal}
        //   hideCancelBtn
        // />
      )}
    </Box>
  );
};
export default GiftPage;
